const tpProductDetail = (function () {
  let bambeProductMediaPromise = null;

  const getBambeProductMedia = function () {
    if (bambeProductMediaPromise) return bambeProductMediaPromise;
    const path = window.location.pathname || '';
    const match = path.match(/\/products\/([^/?#]+)/i);
    if (!match) {
      bambeProductMediaPromise = Promise.resolve(null);
      return bambeProductMediaPromise;
    }
    const handle = match[1];
    bambeProductMediaPromise = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) throw new Error('product.js ' + res.status);
        return res.json();
      })
      .then(function (product) {
        return product && product.media ? product.media : [];
      })
      .catch(function () {
        return null;
      });
    return bambeProductMediaPromise;
  };

  const pickBambeMp4Source = function (sources, targetHeight) {
    if (!sources || !sources.length) return null;
    const mp4s = sources.filter(function (s) {
      return s && (s.format === 'mp4' || (s.mime_type && String(s.mime_type).indexOf('mp4') !== -1));
    });
    if (!mp4s.length) return null;
    const target = Number(targetHeight) || 720;
    let pick =
      mp4s.find(function (s) {
        return Number(s.height) === target;
      }) || null;
    if (!pick) {
      const below = mp4s
        .filter(function (s) {
          return Number(s.height) > 0 && Number(s.height) <= target;
        })
        .sort(function (a, b) {
          return Number(b.height) - Number(a.height);
        });
      pick = below[0] || null;
    }
    if (!pick) {
      pick = mp4s.slice().sort(function (a, b) {
        return Number(a.height || 0) - Number(b.height || 0);
      })[0];
    }
    return pick;
  };

  const applyBambeGalleryVideoQuality = function () {
    const wraps = document.querySelectorAll('.bambe-pdp-autoplay-video[data-bambe-video-target]');
    if (!wraps.length) return Promise.resolve();

    const jobs = [];
    wraps.forEach(function (wrap) {
      if (wrap.getAttribute('data-bambe-quality-applied') === '1') return;
      const target = parseInt(wrap.getAttribute('data-bambe-video-target'), 10) || 720;
      const video = wrap.querySelector('video');
      if (!video) return;
      const mediaId = String(wrap.getAttribute('data-media-id') || '');
      const fallback = wrap.getAttribute('data-bambe-fallback-src') || '';

      const setVideoUrl = function (url, height) {
        if (!url) return;
        const abs = url.indexOf('//') === 0 ? 'https:' + url : url;
        let source = video.querySelector('source');
        if (!source) {
          source = document.createElement('source');
          source.type = 'video/mp4';
          video.appendChild(source);
        }
        if (source.getAttribute('src') === abs || video.currentSrc === abs) {
          wrap.setAttribute('data-bambe-quality-applied', '1');
          wrap.setAttribute('data-bambe-video-quality', (height || target) + 'p');
          return;
        }
        source.setAttribute('src', abs);
        video.setAttribute('preload', 'metadata');
        video.load();
        wrap.setAttribute('data-bambe-quality-applied', '1');
        wrap.setAttribute('data-bambe-video-quality', (height || target) + 'p');
      };

      if (target >= 1080) {
        if (!video.querySelector('source') && fallback) setVideoUrl(fallback, 1080);
        wrap.setAttribute('data-bambe-quality-applied', '1');
        return;
      }

      jobs.push(
        getBambeProductMedia().then(function (mediaList) {
          let pick = null;
          if (mediaList && mediaList.length) {
            const media =
              mediaList.find(function (m) {
                return String(m.id) === mediaId;
              }) ||
              mediaList.find(function (m) {
                return m.media_type === 'video';
              });
            if (media) pick = pickBambeMp4Source(media.sources || [], target);
          }
          if (pick && pick.url) {
            setVideoUrl(pick.url, pick.height || target);
            return;
          }
          // Fallback: rewrite 1080 CDN filename to common 720/480 profiles
          if (fallback) {
            const profiles =
              target <= 480
                ? ['SD-480p-1.5Mbps', 'SD-480p-0.9Mbps', 'SD-480p-1.2Mbps']
                : ['HD-720p-4.5Mbps', 'HD-720p-2.1Mbps', 'HD-720p-3.0Mbps', 'HD-720p-1.5Mbps'];
            const rewritten = profiles.map(function (profile) {
              return fallback.replace(/HD-1080p-[0-9.]+Mbps/i, profile).replace(/SD-480p-[0-9.]+Mbps/i, profile);
            });
            const tryNext = function (i) {
              if (i >= rewritten.length) {
                setVideoUrl(fallback, 1080);
                return Promise.resolve();
              }
              return fetch(rewritten[i], { method: 'HEAD', mode: 'cors' })
                .then(function (res) {
                  if (res.ok) {
                    setVideoUrl(rewritten[i], target);
                    return;
                  }
                  return tryNext(i + 1);
                })
                .catch(function () {
                  return tryNext(i + 1);
                });
            };
            return tryNext(0);
          }
        })
      );
    });

    return Promise.all(jobs);
  };

  return {
    init: function () {
      const mediaGalleryPrd = document.querySelector('media-gallery');
      const galleryLayout = mediaGalleryPrd?.dataset.galleryLayout;
      // Resolve 720/480 CDN sources before gallery autoplay (Liquid only exposes 1080p).
      applyBambeGalleryVideoQuality().finally(() => {
        this.swiperPrd(galleryLayout);
      });
      this.clickShowModalPrd();
      this.setHeightElThumbLeftThumbRight(galleryLayout);
      this.activeTabDesktop();
      this.collapTabMobile();
      this.clickPopupShare();
      this.clickPopupSizeGuide();
      this.copyUrlPrd();
      this.checkFormInfo();
      this.checkedBuyItNow();
      this.stickyPrdDetail();
      this.sizeChartMaxSale();
    },
    swiperPrd: function (galleryLayout) {
      if (!galleryLayout) return;
      let direction = 'horizontal';
      let slidesPerView = 6;
      let thumbSwiper = '';
      const isMobile = innerWidth <= 768;
      if (galleryLayout == 'thumbnails_left' || galleryLayout == 'thumbnails_right') {
        direction = 'vertical';
      }
      if (innerWidth <= 1024) {
        direction = 'horizontal';
        slidesPerView = isMobile ? 'auto' : 5;
      }
      const thumbnail = document.querySelector('.swiper-thumbnail');
      if (galleryLayout != 'no_thumbnails' && thumbnail) {
        window.productThumb = new Swiper(".swiper-thumbnail", {
          spaceBetween: isMobile ? 10 : 12,
          slidesPerView: slidesPerView,
          freeMode: true,
          watchSlidesProgress: true,
          direction: direction,
          navigation: {
            nextEl: ".swiper-next-main-prd",
            prevEl: ".swiper-prev-main-prd",
          },
        });
        thumbSwiper = productThumb;
      }

      // Bambé perf: avoid Swiper MutationObservers on every DOM change (hurts INP).
      // Product gallery media is static after load; slideTo still works without observers.
      // Mobile: fade + autoHeight so shorter photos don’t leave empty space under the image.
      const clearForcedImgStyles = function (root) {
        if (!root) return;
        const imgs = root.querySelectorAll('img');
        for (let i = 0; i < imgs.length; i++) {
          imgs[i].style.removeProperty('max-height');
          imgs[i].style.removeProperty('height');
          imgs[i].style.removeProperty('width');
          imgs[i].style.removeProperty('max-width');
          imgs[i].style.removeProperty('object-fit');
        }
      };
      const syncMobileGalleryHeight = function (swiper) {
        if (!swiper || window.innerWidth > 768) return;
        const active = swiper.slides[swiper.activeIndex];
        if (!active) return;
        const media = active.querySelector('.product__media') || active;
        const img = active.querySelector('img');
        const vv =
          (window.visualViewport && window.visualViewport.height) || window.innerHeight || 0;
        const maxH = Math.max(160, Math.round(vv - 96));
        // Only force contain/cap on short / landscape viewports (Issue J).
        // On normal mobile, width:auto left a huge side letterbox (image ~60% wide).
        const shortViewport = vv > 0 && vv <= 500;

        if (!shortViewport) {
          clearForcedImgStyles(active);
          swiper.el.style.removeProperty('max-height');
          let h = Math.round(media.offsetHeight || active.offsetHeight);
          const galleryW = Math.round(swiper.el.clientWidth || media.offsetWidth || 0);
          if (galleryW > 0 && img) {
            const nw = img.naturalWidth || Number(img.getAttribute('width')) || 0;
            const nh = img.naturalHeight || Number(img.getAttribute('height')) || 0;
            if (nw > 0 && nh > 0) {
              h = Math.round(galleryW * (nh / nw));
            }
          }
          if (h > 0) {
            swiper.wrapperEl.style.height = h + 'px';
            swiper.el.style.height = h + 'px';
            swiper.height = h;
          }
          return;
        }

        let h = Math.round(media.offsetHeight || active.offsetHeight);
        if (h > maxH) h = maxH;
        if (h > 0) {
          swiper.wrapperEl.style.height = h + 'px';
          swiper.el.style.height = h + 'px';
          swiper.el.style.setProperty('max-height', maxH + 'px', 'important');
          swiper.height = h;
          const imgs = active.querySelectorAll('img');
          for (let i = 0; i < imgs.length; i++) {
            imgs[i].style.setProperty('max-height', maxH + 'px', 'important');
            imgs[i].style.setProperty('height', '100%', 'important');
            imgs[i].style.setProperty('width', '100%', 'important');
            imgs[i].style.setProperty('max-width', '100%', 'important');
            imgs[i].style.setProperty('object-fit', 'contain', 'important');
          }
        }
      };

      let galleryResizeTimer = null;
      const onGalleryViewportChange = function () {
        if (!window.productMain) return;
        clearTimeout(galleryResizeTimer);
        galleryResizeTimer = setTimeout(function () {
          if (window.bambeSyncViewportHeight) window.bambeSyncViewportHeight(true);
          try {
            window.productMain.updateSize();
            window.productMain.update();
          } catch (err) {}
          syncMobileGalleryHeight(window.productMain);
        }, 120);
      };
      window.addEventListener('resize', onGalleryViewportChange, { passive: true });
      window.addEventListener('orientationchange', onGalleryViewportChange, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', onGalleryViewportChange, { passive: true });
      }

      const syncGalleryVideos = function (swiper) {
        if (!swiper || !swiper.slides) return;
        applyBambeGalleryVideoQuality().finally(function () {
          swiper.slides.forEach(function (slide, index) {
            const videos = slide.querySelectorAll('video');
            videos.forEach(function (video) {
              video.muted = true;
              video.defaultMuted = true;
              video.setAttribute('muted', '');
              video.setAttribute('playsinline', '');
              video.setAttribute('webkit-playsinline', '');
              if (index === swiper.activeIndex) {
                const tryPlay = function () {
                  const playPromise = video.play();
                  if (playPromise && typeof playPromise.catch === 'function') {
                    playPromise.catch(function () {});
                  }
                };
                if (video.readyState >= 2) {
                  tryPlay();
                } else {
                  video.addEventListener('loadeddata', tryPlay, { once: true });
                  video.addEventListener('canplay', tryPlay, { once: true });
                  tryPlay();
                }
              } else {
                video.pause();
              }
            });
          });
        });
      };

      window.productMain = new Swiper(".swiper-main-prd", {
        spaceBetween: 0,
        slidesPerView: 1,
        watchOverflow: true,
        observer: false,
        observeParents: false,
        autoHeight: isMobile,
        effect: isMobile ? 'fade' : 'slide',
        fadeEffect: isMobile ? { crossFade: true } : undefined,
        speed: isMobile ? 180 : 300,
        a11y: {
          nextSlideMessage: 'الشريحة التالية',
          prevSlideMessage: 'الشريحة السابقة',
        },
        navigation: {
          nextEl: ".swiper-next-main-prd",
          prevEl: ".swiper-prev-main-prd",
        },
        thumbs: {
          swiper: thumbSwiper,
        },
        on: {
          init: function (swiper) {
            syncGalleryVideos(swiper);
            if (isMobile) {
              swiper.el.querySelectorAll('img').forEach(function (img) {
                if (!img.complete) {
                  img.addEventListener(
                    'load',
                    function () {
                      syncMobileGalleryHeight(swiper);
                    },
                    { once: true }
                  );
                }
              });
              requestAnimationFrame(function () {
                syncMobileGalleryHeight(swiper);
              });
            }
          },
          slideChange: function (swiper) {
            syncGalleryVideos(swiper);
            if (isMobile) syncMobileGalleryHeight(swiper);
          },
          slideChangeTransitionEnd: function (swiper) {
            syncGalleryVideos(swiper);
            if (isMobile) syncMobileGalleryHeight(swiper);
          },
        },
      });
    },
    clickShowModalPrd: function () {
      // Lazy-init modal Swiper on first open (saves main-thread work on PDP load).
      // IG/FB iOS WebViews often resize after open — must remeasure slides or images shift.
      let modalPrd = null;
      let resizeTimer = null;

      const getModal = () => {
        const tpModalPrd = document.querySelector('.tp-modal-prd');
        if (tpModalPrd && tpModalPrd.parentElement !== document.body) {
          document.body.appendChild(tpModalPrd);
        }
        return tpModalPrd;
      };

      const clearStaleSlideWidths = (swiper) => {
        if (!swiper || !swiper.slides) return;
        for (let i = 0; i < swiper.slides.length; i++) {
          swiper.slides[i].style.width = '';
          swiper.slides[i].style.maxWidth = '';
        }
        if (swiper.wrapperEl) {
          swiper.wrapperEl.style.height = '';
        }
      };

      const refreshModalSwiper = (index) => {
        if (!modalPrd) return;
        clearStaleSlideWidths(modalPrd);
        try {
          modalPrd.updateSize();
          modalPrd.updateSlides();
          modalPrd.updateSlidesClasses();
          modalPrd.update();
        } catch (err) {
          console.error(err);
        }
        const target =
          typeof index === 'number' && !Number.isNaN(index) ? index : modalPrd.activeIndex || 0;
        modalPrd.slideTo(target, 0);
        // Second frame: layout can settle after visualViewport / font / image decode
        requestAnimationFrame(function () {
          if (!modalPrd) return;
          clearStaleSlideWidths(modalPrd);
          try {
            modalPrd.updateSize();
            modalPrd.updateSlides();
            modalPrd.update();
            modalPrd.slideTo(target, 0);
          } catch (err2) {
            console.error(err2);
          }
        });
      };

      const ensureModalSwiper = () => {
        if (modalPrd || !document.querySelector('.js-tp-modal-prd')) return modalPrd;
        try {
          modalPrd = new Swiper('.js-tp-modal-prd', {
            spaceBetween: 0,
            slidesPerView: 1,
            watchOverflow: true,
            observer: false,
            observeParents: false,
            resizeObserver: true,
            updateOnWindowResize: true,
            // Higher threshold so a double-tap doesn't start a slide "swim"
            threshold: 12,
            resistanceRatio: 0.65,
            navigation: {
              nextEl: '.swiper-next-tp-modal-prd',
              prevEl: '.swiper-prev-tp-modal-prd',
            },
            on: {
              slideChangeTransitionStart: function () {
                bambeLightboxZoom.reset(false);
              },
            },
          });
        } catch (err) {
          console.error(err);
          modalPrd = null;
        }
        return modalPrd;
      };

      // PhotoSwipe-style lightbox zoom: double-tap + two-finger pinch + pan
      // Model: translate3d + scale with origin 0 0 (same as PhotoSwipe zoom-wrap).
      const bambeLightboxZoom = (function createBambeLightboxZoom() {
        const MIN = 1;
        const MAX = 3;
        const DOUBLE_TAP_SCALE = 2;
        let scale = 1;
        let panX = 0;
        let panY = 0;
        let lastTapAt = 0;
        let lastTapX = 0;
        let lastTapY = 0;
        let unlockTimer = null;
        let bound = false;

        let panning = false;
        let panStartX = 0;
        let panStartY = 0;
        let panBaseX = 0;
        let panBaseY = 0;
        let panMoved = false;

        let pinching = false;
        let pinchStartDist = 0;
        let pinchStartScale = 1;
        let pinchStartPanX = 0;
        let pinchStartPanY = 0;
        let pinchStartMidX = 0;
        let pinchStartMidY = 0;
        let pinchStartImgLeft = 0;
        let pinchStartImgTop = 0;

        const activeImg = () =>
          document.querySelector(
            '.tp-modal-prd.show-modal-prd .js-tp-modal-prd .swiper-slide-active .swiper-zoom-container img, .tp-modal-prd.show-modal-prd .js-tp-modal-prd .swiper-slide-active img'
          );
        const activeSlide = () =>
          document.querySelector('.tp-modal-prd.show-modal-prd .js-tp-modal-prd .swiper-slide-active');

        const setSwiperMove = (allow) => {
          if (modalPrd) modalPrd.allowTouchMove = allow;
        };

        const syncZoomedClass = () => {
          const slide = activeSlide();
          if (!slide) return;
          if (scale > 1.02) {
            slide.classList.add('bambe-zoomed');
            setSwiperMove(false);
          } else {
            slide.classList.remove('bambe-zoomed');
            setSwiperMove(true);
          }
        };

        // PhotoSwipe-style bounds: pan until image edges meet the viewport edges
        // (old symmetric clamp blocked max top/left after a centered pinch).
        const clampPan = () => {
          const img = activeImg();
          const slide = activeSlide();
          if (!img || !slide) return;

          const sw = slide.clientWidth;
          const sh = slide.clientHeight;
          const iw = img.offsetWidth * scale;
          const ih = img.offsetHeight * scale;

          // Layout position of the untransformed image inside the slide
          // (flex-centered). With origin 0 0, visual = layout + pan.
          const layoutLeft = img.offsetLeft;
          const layoutTop = img.offsetTop;

          let minX;
          let maxX;
          let minY;
          let maxY;

          if (iw > sw) {
            // Can slide until left edge hits 0, or right edge hits sw
            maxX = -layoutLeft;
            minX = sw - iw - layoutLeft;
          } else {
            // Smaller than viewport — keep centered (tiny slack)
            const cx = (sw - iw) / 2 - layoutLeft;
            minX = cx;
            maxX = cx;
          }

          if (ih > sh) {
            maxY = -layoutTop;
            minY = sh - ih - layoutTop;
          } else {
            const cy = (sh - ih) / 2 - layoutTop;
            minY = cy;
            maxY = cy;
          }

          panX = Math.max(minX, Math.min(maxX, panX));
          panY = Math.max(minY, Math.min(maxY, panY));
        };

        const apply = (animate) => {
          const img = activeImg();
          if (!img) return;
          clampPan();
          img.style.transition = animate
            ? 'transform 0.28s cubic-bezier(0.2, 0, 0.2, 1)'
            : 'none';
          img.style.transformOrigin = '0 0';
          img.style.transform =
            'translate3d(' + panX + 'px,' + panY + 'px,0) scale(' + scale + ')';
          syncZoomedClass();
        };

        const clearInline = (img) => {
          if (!img) return;
          img.style.transition = '';
          img.style.transform = '';
          img.style.transformOrigin = '';
        };

        const zoomOut = (animate) => {
          const img = activeImg();
          scale = 1;
          panX = 0;
          panY = 0;
          pinching = false;
          panning = false;
          if (img) apply(animate !== false);
          if (animate === false) {
            clearInline(img);
            const slide = activeSlide();
            if (slide) slide.classList.remove('bambe-zoomed');
            setSwiperMove(true);
          } else if (img) {
            setTimeout(function () {
              if (scale === 1) {
                clearInline(img);
                const slide = activeSlide();
                if (slide) slide.classList.remove('bambe-zoomed');
                setSwiperMove(true);
              }
            }, 300);
          }
        };

        const zoomToAt = (clientX, clientY, targetScale) => {
          const img = activeImg();
          const slide = activeSlide();
          if (!img || !slide) return;
          const rect = img.getBoundingClientRect();
          if (rect.width < 1 || rect.height < 1) return;

          const localX = (clientX - rect.left) / scale;
          const localY = (clientY - rect.top) / scale;
          const layoutLeft = rect.left - panX;
          const layoutTop = rect.top - panY;

          scale = targetScale;
          panX = clientX - layoutLeft - localX * scale;
          panY = clientY - layoutTop - localY * scale;
          apply(true);
        };

        const toggleAt = (clientX, clientY) => {
          if (scale > 1.05) zoomOut(true);
          else zoomToAt(clientX, clientY, DOUBLE_TAP_SCALE);
        };

        const touchDist = (a, b) => {
          const dx = a.clientX - b.clientX;
          const dy = a.clientY - b.clientY;
          return Math.sqrt(dx * dx + dy * dy);
        };

        const isZoomTarget = (target) => {
          if (!target || !target.closest) return false;
          if (
            target.closest(
              '.tp-icon-close-prd, .swiper-button-next, .swiper-button-prev, .swiper-next-tp-modal-prd, .swiper-prev-tp-modal-prd'
            )
          ) {
            return false;
          }
          return !!target.closest(
            '.swiper-zoom-container, .js-tp-modal-prd .swiper-slide img, .js-tp-modal-prd .swiper-slide'
          );
        };

        const lockSwipeBriefly = () => {
          setSwiperMove(false);
          clearTimeout(unlockTimer);
          unlockTimer = setTimeout(function () {
            if (scale <= 1.02 && !pinching) setSwiperMove(true);
          }, 340);
        };

        const beginPinch = (t0, t1) => {
          const img = activeImg();
          if (!img) return;
          pinching = true;
          panning = false;
          lastTapAt = 0;
          clearTimeout(unlockTimer);
          setSwiperMove(false);

          pinchStartDist = touchDist(t0, t1) || 1;
          pinchStartScale = scale;
          pinchStartPanX = panX;
          pinchStartPanY = panY;
          pinchStartMidX = (t0.clientX + t1.clientX) / 2;
          pinchStartMidY = (t0.clientY + t1.clientY) / 2;

          const rect = img.getBoundingClientRect();
          pinchStartImgLeft = rect.left - panX;
          pinchStartImgTop = rect.top - panY;
        };

        const movePinch = (t0, t1) => {
          if (!pinching) return;
          const dist = touchDist(t0, t1) || 1;
          let next = pinchStartScale * (dist / pinchStartDist);
          next = Math.max(MIN, Math.min(MAX, next));

          const midX = (t0.clientX + t1.clientX) / 2;
          const midY = (t0.clientY + t1.clientY) / 2;

          const localX =
            (pinchStartMidX - pinchStartImgLeft - pinchStartPanX) / pinchStartScale;
          const localY =
            (pinchStartMidY - pinchStartImgTop - pinchStartPanY) / pinchStartScale;

          scale = next;
          panX = midX - pinchStartImgLeft - localX * scale;
          panY = midY - pinchStartImgTop - localY * scale;
          apply(false);
        };

        const endPinch = () => {
          if (!pinching) return;
          pinching = false;
          if (scale < 1.08) {
            zoomOut(true);
          } else {
            clampPan();
            apply(true);
            setSwiperMove(false);
          }
        };

        const bind = (tpModalPrd) => {
          if (!tpModalPrd || bound) return;
          bound = true;

          tpModalPrd.addEventListener(
            'touchstart',
            function (e) {
              if (!tpModalPrd.classList.contains('show-modal-prd')) return;
              if (!isZoomTarget(e.target)) return;
              if (!e.touches || e.touches.length === 0) return;

              if (e.touches.length >= 2) {
                e.preventDefault();
                beginPinch(e.touches[0], e.touches[1]);
                return;
              }

              const t = e.touches[0];
              const now = Date.now();
              if (lastTapAt && now - lastTapAt < 300) {
                setSwiperMove(false);
                clearTimeout(unlockTimer);
              }

              if (scale > 1.02) {
                panning = true;
                panMoved = false;
                panStartX = t.clientX;
                panStartY = t.clientY;
                panBaseX = panX;
                panBaseY = panY;
              }
            },
            { passive: false }
          );

          tpModalPrd.addEventListener(
            'touchmove',
            function (e) {
              if (!tpModalPrd.classList.contains('show-modal-prd')) return;

              if (e.touches && e.touches.length >= 2) {
                e.preventDefault();
                if (!pinching) beginPinch(e.touches[0], e.touches[1]);
                else movePinch(e.touches[0], e.touches[1]);
                return;
              }

              if (pinching) {
                endPinch();
                return;
              }

              if (!panning || scale <= 1.02) return;
              if (!e.touches || e.touches.length !== 1) return;
              const t = e.touches[0];
              const dx = t.clientX - panStartX;
              const dy = t.clientY - panStartY;
              if (Math.abs(dx) + Math.abs(dy) > 6) panMoved = true;
              panX = panBaseX + dx;
              panY = panBaseY + dy;
              apply(false);
              e.preventDefault();
            },
            { passive: false }
          );

          tpModalPrd.addEventListener(
            'touchend',
            function (e) {
              if (!tpModalPrd.classList.contains('show-modal-prd')) return;

              if (e.touches && e.touches.length >= 2) {
                beginPinch(e.touches[0], e.touches[1]);
                return;
              }
              if (pinching) {
                endPinch();
                return;
              }

              if (!isZoomTarget(e.target)) return;
              if (!e.changedTouches || e.changedTouches.length !== 1) return;

              const wasPanning = panning;
              const moved = panMoved;
              panning = false;
              panMoved = false;
              if (wasPanning && scale > 1.02 && moved) return;

              const touch = e.changedTouches[0];
              const now = Date.now();
              const dt = now - lastTapAt;
              const dx = Math.abs(touch.clientX - lastTapX);
              const dy = Math.abs(touch.clientY - lastTapY);

              if (lastTapAt && dt > 0 && dt < 300 && dx < 40 && dy < 40) {
                e.preventDefault();
                lastTapAt = 0;
                clearTimeout(unlockTimer);
                toggleAt(touch.clientX, touch.clientY);
              } else {
                lastTapAt = now;
                lastTapX = touch.clientX;
                lastTapY = touch.clientY;
                if (scale <= 1.02) lockSwipeBriefly();
              }
            },
            { passive: false }
          );

          tpModalPrd.addEventListener(
            'touchcancel',
            function () {
              if (pinching) endPinch();
              panning = false;
            },
            { passive: true }
          );

          tpModalPrd.addEventListener('dblclick', function (e) {
            if (!tpModalPrd.classList.contains('show-modal-prd')) return;
            if (!isZoomTarget(e.target)) return;
            e.preventDefault();
            lastTapAt = 0;
            toggleAt(e.clientX, e.clientY);
          });
        };

        return {
          bind: bind,
          reset: zoomOut,
          isZoomed: function () {
            return scale > 1.02;
          },
        };
      })();


      const zoomOutSafe = () => {
        bambeLightboxZoom.reset(false);
      };

      const scheduleRefresh = () => {
        const tpModalPrd = getModal();
        if (!tpModalPrd || !tpModalPrd.classList.contains('show-modal-prd') || !modalPrd) return;
        // Do not remount/update while zoomed — kills zoom on iOS WebViews
        if (bambeLightboxZoom.isZoomed()) return;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (bambeLightboxZoom.isZoomed()) return;
          if (window.bambeSyncViewportHeight) window.bambeSyncViewportHeight(true);
          refreshModalSwiper(modalPrd.activeIndex);
        }, 120);
      };

      // Keep overlay on body so fixed positioning is never trapped by section layout
      getModal();
      bambeLightboxZoom.bind(getModal());

      document.addEventListener('click', function (e) {
        const tpModalPrd = getModal();
        if (!tpModalPrd) return;
        const openTrigger = e.target.closest('.click-modal-prd');
        if (openTrigger) {
          const slide = openTrigger.closest('.swiper-slide');
          const dataIndex = slide ? parseInt(slide.dataset.indexModal, 10) : 0;
          if (window.bambeSyncViewportHeight) window.bambeSyncViewportHeight(true);
          bambeLightboxZoom.reset(false);
          tpModalPrd.classList.add('show-modal-prd');
          document.body.classList.add('overflow-hidden');
          document.documentElement.classList.add('overflow-hidden');
          const swiper = ensureModalSwiper();
          // Wait one frame so visibility/size are real before measuring (avoids 0-width init)
          requestAnimationFrame(function () {
            refreshModalSwiper(dataIndex);
          });
          return;
        }
        if (e.target.closest('.tp-icon-close-prd') || e.target === tpModalPrd) {
          zoomOutSafe();
          tpModalPrd.classList.remove('show-modal-prd');
          document.body.classList.remove('overflow-hidden');
          document.documentElement.classList.remove('overflow-hidden');
        }
      });

      window.addEventListener('resize', scheduleRefresh, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', scheduleRefresh, { passive: true });
        window.visualViewport.addEventListener('scroll', scheduleRefresh, { passive: true });
      }
      window.addEventListener('orientationchange', scheduleRefresh, { passive: true });
    },
    setHeightElThumbLeftThumbRight: function (galleryLayout) {
      // setHeight slide
      if (!galleryLayout) return;
      if (galleryLayout != 'thumbnails_bottom' && innerWidth > 1024) {
        let box = null;

        box = document.querySelector('.swiper-main-prd img') ||
          document.querySelector('.swiper-main-prd video') ||
          document.querySelector('.swiper-main-prd iframe');

        if (!box || box.clientHeight === 0) {
          box = document.querySelector('.swiper-main-prd .swiper-slide-active');
        }

        const tpImgThumb = document.querySelector(".swiper-thumbnail");

        if (tpImgThumb && box && box.clientHeight > 0) {
          tpImgThumb.style.height = box.clientHeight + "px";
        }
      }
    },
    activeTabDesktop: function () {
      const prd_tab = document.querySelector('.tp-product-tabs');
      if (!prd_tab) return;
      document.addEventListener('click', function (e) {
        const el = e.target;
        if (el.classList.contains('js-tab-item')) {
          const parentNode = el.parentNode
          parentNode.querySelector('.active').classList.remove('active');
          el.classList.add('active')
          const tabContents = document.querySelectorAll('.js-prd-tab-content');
          if (tabContents.length > 0) {
            tabContents.forEach(function (tabContent) {
              if (tabContent.getAttribute('data-number') === el.getAttribute('data-number')) {
                tabContent.classList.add('active');
                tabContent.classList.remove('md:hidden');
              }
              else {
                tabContent.classList.add('md:hidden');
                tabContent.classList.remove('active');
              }
            })
          }
        }
      })
    },
    collapTabMobile: function () {
      if (innerWidth < 768) {
        const collapTabs = document.querySelectorAll('.tp-collap-tab');
        const parentTab = document.querySelector('.tp-product-tabs__inner');
        if (parentTab && !parentTab.classList.contains('tp-collap-tab-main')) {
          parentTab.classList.add('tp-collap-tab-main');
        }
        if (collapTabs.length == 0) return;
        collapTabs.forEach(function (collapTab) {
          if (collapTab.hasAttribute('open')) {
            collapTab.removeAttribute('open')
          }
        })

      }
    },
    clickPopupShare: function () {
      const overlayBody = document.querySelector('.tp-close-overlay');
      document.addEventListener('click', function (e) {
        const el = e.target;
        const productColumnSticky = document.querySelector('.product__info-container');

        if (el.classList.contains('button-popup')) {
          const parentNode = el.closest('.tp-popup-parent');
          const content = parentNode.querySelector('.tp-popup-parent__content');
          if (productColumnSticky.classList.contains('product__column-sticky')) {
            productColumnSticky.classList.remove('product__column-sticky');
          }
          overlayBody.classList.add('is-visible-popup-detail');
          content.classList.add('open');

        }
        if (el.classList.contains('close-popup') || !el.closest('.tp-popup-parent__content') && !el.classList.contains('button-popup')) {
          const contents = document.querySelectorAll('.tp-popup-parent__content');
          overlayBody.classList.remove('is-visible-popup-detail');
          contents.forEach(element => {
            element.classList.remove('open');
          });

        }
      });
    },
    clickPopupSizeGuide: function () {
      const overlayBody = document.querySelector('.tp-close-overlay');
      document.addEventListener('click', function (e) {
        const el = e.target;

        if (el.classList.contains('button-popup-size-guide')) {
          const parentNode = el.closest('.tp-popup-parent');
          const content = parentNode.querySelector('.tp-popup-parent__content');
          if (productColumnSticky.classList.contains('product__column-sticky')) {
            productColumnSticky.classList.remove('product__column-sticky');
          }
          overlayBody.classList.add('is-visible-popup-detail');
          content.classList.add('open');

        }
        if (el.classList.contains('close-popup') || !el.closest('.tp-popup-parent__content') && !el.classList.contains('button-popup')) {
          const contents = document.querySelectorAll('.tp-popup-parent__content');
          overlayBody.classList.remove('is-visible-popup-detail');
          contents.forEach(element => {
            element.classList.remove('open');
          });

        }
      });
    },
    checkFormInfo() {
      const urlInfo = window.location.href;
      const overlayBody = document.querySelector('.tp-close-overlay');
      const formInfo = document.querySelector('.form-infor');
      const formErr = document.querySelector('.form-infor-body.noti-error');
      const formSuccess = document.querySelector('.form-infor-body.noti-success');
      document.querySelector('.form-infor,.close-form-info').addEventListener('click', (e) => {
        const target = e.currentTarget;

        const closet = target.closest('.form-infor');
        e.preventDefault();
        if (closet.classList.contains('show-noti-form')) {
          closet.classList.remove('show-noti-form')
          overlayBody.classList.remove('is--visible-form-info');
          document.querySelector('html').classList.remove('tp-over-flow-hidden-form-info');
        };
      });
      if (urlInfo.indexOf('contact_posted=true') >= 1) {
        formInfo.classList.add('show-noti-form');
        overlayBody.classList.add('is--visible-form-info');
        document.querySelector('html').classList.add('tp-over-flow-hidden-form-info');
        formErr.style.display = "none";
        const newURL = location.href.split("?")[0];
        window.history.pushState('object', document.title, newURL);
      };
      if (urlInfo.indexOf('contact%5Btags%5D=newsletter&form_type=contact') >= 1) {
        formInfo.classList.add('show-noti-form');
        overlayBody.classList.add('is--visible-form-info');
        document.querySelector('html').classList.add('tp-over-flow-hidden-form-info')
        formSuccess.style.display = "none";
        const newURL = location.href.split("?")[0];
        window.history.pushState('object', document.title, newURL);
      }
    },
    copyUrlPrd: function () {
      const copyButton = document.querySelector('.product-share__link');
      if (!copyButton) return;
      const textCopied = document.querySelector('.text-copied');
      let timeoutId = null;
      const copyUrl = copyButton.getAttribute('data-url');
      copyButton.addEventListener('click', (e) => {
        navigator.clipboard.writeText(copyUrl);
        copyButton.classList.add('hidden');
        textCopied.classList.remove('hidden');
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          textCopied.classList.add('hidden');
          copyButton.classList.remove('hidden');
        }, 2000);
      });
    },
    checkedBuyItNow: function () {
      const agreeTerms = document.querySelector('.agree_terms_conditions');
      if (!agreeTerms) return;

      const sync = () => {
        if (typeof window.bambeSyncOrderNowButton === 'function') {
          window.bambeSyncOrderNowButton();
        }
      };

      sync();
      agreeTerms.addEventListener('change', sync);
    },
    stickyPrdDetail: function () {
      const stickyPrdDetail = document.querySelector('.sticky-product-detail');
      if (!stickyPrdDetail) return;
      scrollStickAtc();
      changeVatiant();
      function scrollStickAtc() {
        const rawThreshold = parseFloat(stickyPrdDetail.getAttribute('data-scroll-threshold') || '60');
        const thresholdPct = Math.min(90, Math.max(0, Number.isFinite(rawThreshold) ? rawThreshold : 60));
        const threshold = thresholdPct / 100;

        function updateStickyVisibility() {
          const footerBottom = document.querySelector('.footer__bottom');
          const scrollable = Math.max(
            document.documentElement.scrollHeight - window.innerHeight,
            1
          );
          const progress = window.scrollY / scrollable;
          let hide = progress < threshold;

          if (!hide && footerBottom) {
            const positionFt = footerBottom.getBoundingClientRect();
            if (positionFt.bottom <= window.innerHeight) {
              hide = true;
            }
          }

          stickyPrdDetail.style.bottom = hide
            ? '-' + stickyPrdDetail.clientHeight + 'px'
            : '0';
        }

        let stickyRaf = 0;
        const scheduleStickyUpdate = () => {
          if (stickyRaf) return;
          const tick = () => {
            stickyRaf = 0;
            updateStickyVisibility();
          };
          if (typeof requestAnimationFrame === 'function') {
            stickyRaf = requestAnimationFrame(tick);
          } else {
            stickyRaf = setTimeout(tick, 16);
          }
        };
        window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
        window.addEventListener('resize', scheduleStickyUpdate);
        updateStickyVisibility();
      }
      function changeVatiant() {
        const selectSticky = stickyPrdDetail.querySelector('.select__select');
        if (!selectSticky) return;
        selectSticky.addEventListener('change', function (e) {
          const el = e.target;
          const dataOption = selectSticky.options[selectSticky.selectedIndex];
          const inputVariantAtc = document.querySelectorAll('.product-variant-id');

          const price = dataOption.getAttribute('data-price');
          const priceCompare = dataOption.getAttribute('data-price-compare');
          inputVariantAtc.forEach(function (input) {
            input.value = el.value;
          })
          const renderPrice = new VariantSelects();
          // Pass sticky element so renderPrice uses it as parent (not a bare boolean)
          renderPrice.renderPrice(price, priceCompare, stickyPrdDetail);
        })
      }

    },
    sizeChartMaxSale: function () {

      const parenSizeChart = document.querySelector('.sfp-size-chart');
      if (!parenSizeChart) return;

      const sizeChartInterval = setInterval(openSizeChart, 500);
      document.addEventListener('click', function (e) {
        closeSizeChart(e)
      })

      function openSizeChart() {
        const btnSize = parenSizeChart.querySelector('.size-chart-btn');
        if (!btnSize) return;
        clearInterval(sizeChartInterval);
        const productColumnSticky = document.querySelector('.product__info-container');
        if (productColumnSticky.classList.contains('product__column-sticky')) {
          productColumnSticky.classList.remove('product__column-sticky');
        }

        btnSize.addEventListener('click', function () {
          const html = document.querySelector('html');
          const overlayBody = document.querySelector('.tp-close-overlay');
          html.classList.add('tp-over-flow-hidden-sizechart');
          overlayBody.classList.add('is-visible-sizechart');
        })
      }
      function closeSizeChart(e) {
        const html = document.querySelector('html');
        const overlayBody = document.querySelector('.tp-close-overlay');
        const el = e.target;
        if (el.classList.contains('button-close') || el == overlayBody && !el.classList.contains('size-chart-btn')) {
          html.classList.remove('tp-over-flow-hidden-sizechart');
          overlayBody.classList.remove('is-visible-sizechart');
        }
      }
    }
  }
})()
tpProductDetail.init()
document.addEventListener("shopify:section:load", tpProductDetail);
document.addEventListener("shopify:section:unload", tpProductDetail);



